import type { SearchFilterState } from '../../types'
import { formatText } from './helpers'
import { SEGMENT_MAP } from './segmentMap'

/**
 * Returns a comma-separated media-type string for the criteria.
 * Defaults to all three types when none are explicitly selected.
 */
export const getMediaTypeStrings = (state: SearchFilterState): string => {
  let mediaTypes: string[] = []
  if (state.mediaType.document) mediaTypes.push('Documents')
  if (state.mediaType.image) mediaTypes.push('Images')
  if (state.mediaType.video) mediaTypes.push('Videos')

  if (Object.values(state.mediaType).every((i) => i === false)) {
    mediaTypes = ['Documents', 'Images', 'Videos']
  }

  return mediaTypes.join(',')
}

/**
 * Returns a comma-separated list of active engine market keys,
 * or `null` when no markets are selected.
 */
export const getEngineMarkets = (state: SearchFilterState): string | null => {
  const markets: string[] = []
  const stateIndustries = Object.entries(state.industries)

  if (stateIndustries.every(([_key, value]) => value !== true)) {
    return null
  }

  stateIndustries.forEach(([key, value]) => {
    if (value) markets.push(key)
  })

  return markets.join(',')
}

/**
 * Returns the `Status:Current` / `Status:Non-Current` / `Status:Both` segment string.
 * Defaults to `Status:Both` when neither flag is set.
 */
export const getStatus = (state: SearchFilterState): string => {
  if (state.status.current && state.status.nonCurrent) return 'Status:Both'
  if (state.status.current) return 'Status:Current'
  if (state.status.nonCurrent) return 'Status:Non-Current'
  return 'Status:Both'
}

/**
 * Iterates the segment map and returns a `Label:value` string for every
 * non-empty, non-false, non-null entry.
 */
export const formatSegments = (state: SearchFilterState): string[] => {
  const segmentStrings: string[] = []
  for (const [label, def] of Object.entries(SEGMENT_MAP)) {
    const value = def.get(state)
    if (Array.isArray(value) && value.length === 0) continue
    if (
      value !== null &&
      value !== '' &&
      value !== false &&
      value !== undefined
    ) {
      segmentStrings.push(formatText(value, label))
    }
  }
  return segmentStrings
}
